/* eslint-disable react/jsx-tag-spacing */ /* for minified SVGs */
import React from 'react';
import CreateIconComponent, { CreateIconComponentProps } from '../CreateIconComponent';

export const RightCaretIcon = ({
  title = 'RightCaret',
  ...props
}: CreateIconComponentProps): JSX.Element => (
  <CreateIconComponent title={title} viewBox="0 0 9 15" {...props}>
    {/* prettier-ignore */}
    <path fillRule="evenodd" clipRule="evenodd" d="M8.201 8.215a1.027 1.027 0 00-.01-1.459L2.271.82A1.02 1.02 0 001.534.5 1.028 1.028 0 00.8 2.243l-.004.003 5.19 5.226-5.184 5.264.004.004a1.028 1.028 0 00.722 1.76c.298 0 .561-.13.748-.333l5.93-5.95-.004-.002z"/>
  </CreateIconComponent>
);

export default RightCaretIcon;
